import {Injectable} from '@angular/core';

/**
 * Thin, injectable wrapper around `window.location.href` assignment.
 *
 * Direct `window.location.href = ...` assignments cannot be intercepted in
 * Cypress component tests: the `href` accessor on the browser's `Location`
 * instance is non-configurable, so `Object.defineProperty` on it throws
 * ("Cannot redefine property: href") and the real navigation would otherwise
 * detach the test fixture mid-test. Routing hard navigations through this
 * service gives tests a mockable seam without changing runtime behavior.
 */
@Injectable({providedIn: 'root'})
export class WindowLocationService {
  navigateTo(url: string): void {
    window.location.href = url;
  }
}

